import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {districtFields} from "../districts/districts.graphql";

export const wardFields = `
id
wardUniqueId
wardName
wardPostcode
napaId
wardParentDistric {
  ${districtFields}
}
`

export const GET_ALL_WARDS = gql`
query GetAllWards($districUniqueId: String) {
  getAllWards(districUniqueId: $districUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${wardFields}
    }
  }
}
`
